import { Pipe, PipeTransform } from '@angular/core';
import { SubscriptionPlans } from '../../../../../user/user/user.model';
import {
  CHRONIC_DISEASES_GROUP_TITLE,
  HEALTH_GROUP_TITLE,
  HOUSING_GROUP_TITLE,
  HWW_GROUP_TITLE,
  POI_GROUP_TITLE,
  WEALTH_GROUP_TITLE,
} from '../layers-menu.service';

@Pipe({
  name: 'groupTitleFormatter',
})
export class GroupTitleFormatterPipe implements PipeTransform {
  transform(title: string, plan?: SubscriptionPlans | null): string {
    // Change group titles for different subscriptions according to https://docs.google.com/spreadsheets/d/1CJ2uHd4AVTNmAIJzIdTHm9WY7MatiMLXAeDypBfmQ8Q/edit#gid=0
    switch (title) {
      case WEALTH_GROUP_TITLE:
        return 'Income & Employment';

      case HOUSING_GROUP_TITLE:
        if (
          plan === SubscriptionPlans.ENTERPRISE ||
          plan === SubscriptionPlans.REALTOR ||
          plan === SubscriptionPlans.SITE_SELECTION ||
          plan === SubscriptionPlans.REAL_ESTATE
        ) {
          return 'Real estate';
        } else {
          return title;
        }

      case CHRONIC_DISEASES_GROUP_TITLE:
        if (
          plan === SubscriptionPlans.ENTERPRISE ||
          plan === SubscriptionPlans.SITE_SELECTION
        ) {
          return 'Healthcare needs';
        }
        return title;

      case POI_GROUP_TITLE:
        if (
          plan === SubscriptionPlans.ENTERPRISE ||
          plan === SubscriptionPlans.SITE_SELECTION
        ) {
          return 'Competition & POI';
        } else if (
          plan === SubscriptionPlans.COMMUNITY_COMPASS ||
          plan === SubscriptionPlans.REALTOR ||
          plan === SubscriptionPlans.HOME_SEARCH ||
          plan === SubscriptionPlans.REAL_ESTATE
        ) {
          return 'Nearby amenities';
        } else if (plan === SubscriptionPlans.KNOW_YOUR_COUNTRY) {
          return 'Amenities';
        } else {
          return title;
        }
      case HEALTH_GROUP_TITLE:
        return 'Health & Environment';

      case HWW_GROUP_TITLE:
        if (
          plan === SubscriptionPlans.COMMUNITY_COMPASS ||
          plan === SubscriptionPlans.REALTOR ||
          plan === SubscriptionPlans.HOME_SEARCH ||
          plan === SubscriptionPlans.REAL_ESTATE ||
          !plan
        ) {
          return 'Neighborhood Summary';
        } else {
          return title;
        }
      // Simply return title as it do not require changing
      default:
        return title;
    }
  }
}
